import { render } from "./AppHome.vue?vue&type=template&id=02d053c2"
import script from "./AppHome.vue?vue&type=script&lang=js"
export * from "./AppHome.vue?vue&type=script&lang=js"
script.render = render

export default script